// filtri/punti.ts — gli indici dei punti del volto di MediaPipe Face Landmarker (478 punti) che servono ai filtri.
// "Destro" e "sinistro" sono DELLA PERSONA: nel fotogramma non specchiato l'occhio destro della persona sta a
// sinistra dell'immagine.
//
// QUESTO FILE NON SI MODIFICA nei filtri: per un punto che qui manca si usa l'indice MediaPipe direttamente,
// con un commento che dice cos'è.

export const P = {
  fronteAlto: 10, // attaccatura dei capelli al centro (la cima del volto che MediaPipe vede)
  fronte: 151, // centro della fronte
  glabella: 9, // tra le sopracciglia
  radiceNaso: 168,
  dorsoNaso: 6,
  puntaNaso: 1,
  sottoNaso: 2, // base del naso, sopra il labbro
  labbroSuperioreEsterno: 0,
  labbroSuperioreInterno: 13,
  labbroInferioreInterno: 14,
  labbroInferioreEsterno: 17,
  angoloBoccaDestro: 61,
  angoloBoccaSinistro: 291,
  mento: 152,
  // occhi
  occhioDestroEsterno: 33,
  occhioDestroInterno: 133,
  occhioDestroAlto: 159,
  occhioDestroBasso: 145,
  occhioSinistroEsterno: 263,
  occhioSinistroInterno: 362,
  occhioSinistroAlto: 386,
  occhioSinistroBasso: 374,
  irideDestra: 468, // centro; contorno 469..472
  irideSinistra: 473, // centro; contorno 474..477
  // sopracciglia (punto centrale in alto)
  sopracciglioDestroCentro: 105,
  sopracciglioSinistroCentro: 334,
  // lati del volto
  guanciaDestra: 50,
  guanciaSinistra: 280,
  zigomoDestro: 234, // punto più largo del volto, davanti all'orecchio
  zigomoSinistro: 454,
  tempiaDestra: 127,
  tempiaSinistra: 356,
  mascellaDestra: 172,
  mascellaSinistra: 397,
} as const;

/** Contorno del volto, in senso orario partendo dalla fronte (36 punti). */
export const OVALE = [
  10, 338, 297, 332, 284, 251, 389, 356, 454, 323, 361, 288, 397, 365, 379, 378, 400, 377, 152, 148, 176, 149, 150, 136,
  172, 58, 132, 93, 234, 127, 162, 21, 54, 103, 67, 109,
] as const;

/** Contorno esterno delle labbra (20 punti). */
export const LABBRA_ESTERNE = [61, 146, 91, 181, 84, 17, 314, 405, 321, 375, 291, 409, 270, 269, 267, 0, 37, 39, 40, 185] as const;

/** Contorno interno delle labbra: l'apertura della bocca (20 punti). */
export const LABBRA_INTERNE = [78, 95, 88, 178, 87, 14, 317, 402, 318, 324, 308, 415, 310, 311, 312, 13, 82, 81, 80, 191] as const;

export const OCCHIO_DESTRO = [33, 7, 163, 144, 145, 153, 154, 155, 133, 173, 157, 158, 159, 160, 161, 246] as const;
export const OCCHIO_SINISTRO = [263, 249, 390, 373, 374, 380, 381, 382, 362, 398, 384, 385, 386, 387, 388, 466] as const;

export const SOPRACCIGLIO_DESTRO = [70, 63, 105, 66, 107] as const; // dall'esterno verso il naso
export const SOPRACCIGLIO_SINISTRO = [300, 293, 334, 296, 336] as const;

export const IRIDE_DESTRA = [469, 470, 471, 472] as const;
export const IRIDE_SINISTRA = [474, 475, 476, 477] as const;

export const NUMERO_PUNTI = 478;
